module.exports = __webpack_public_path__ + "img/img-adf2376e.c180d5cd.png";